import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import Spinner from '../../components/spinner/Spinner';
import { ChangePasswordStep1Service } from '../../services/api';
import RequestPassword from './RequestPassword';
import { toast } from 'react-toastify';

//Componentes

function RequestPasswordContainer() {
    const [loader, setLoader] = useState(false);
    const [emailSent, setEmailSent] = useState(false);

    const { register, handleSubmit, watch, setError, formState } = useForm();

    const onSubmitUser = async (data) => {
        try {
            setLoader(true);

            const res = await ChangePasswordStep1Service.send(data);

            if (res) {
                setEmailSent(true);
            }

            setLoader(false);
        } catch (err) {
            setLoader(false);
            return err;
        }
    };

    return loader ? (
        <Spinner />
    ) : (
        <RequestPassword
            functions={{
                register,
                handleSubmit,
                watch,
                setError,
                formState,
                onSubmitUser,
            }}
            states={{ emailSent }}
        />
    );
}

export default RequestPasswordContainer;
